import { useContext, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
// Screens
import CentroNotificaciones from "../screens/Jurados/CentroNotificaciones/CentroNotificaciones";
// import { GestionConvocatorias } from "../screens/Admin/Convocatorias/GestionarConvocatorias/gestion.view";
import { AdminConvocatorias } from "../screens/Admin/Convocatorias/GestionarConvocatorias/adminConvicatoria";
import { InfoConvocatorias } from "../screens/Admin/Convocatorias/InfoConvocatorias/info.view";
import { CronogramaActividades } from "../screens/Admin/Convocatorias/CronogramaActividades/CronogramaActividades";
import { EvaluacionCriterios } from "../screens/EvaluacionCriterios/componant/EvaluacionCriterios";
// import { InfoConvocatoria } from "../screens/Admin/Convocatorias/InfoConvocatorias/InfoConvocatoria";
import { Infojurados } from "../screens/Jurados/InfoJurados/Infojurados.view";
import { DocumentosAdministrativos } from "../screens/Admin/Convocatorias/DocumentosAdministrativos/documentosAdministrativos.view";
import { GestionarPostulaciones } from "../screens/Admin/Convocatorias/GestionarPostulaciones/GestionarPostulaciones";
import { Cronograma } from "../screens/Admin/Convocatorias/Cronograma/Cronograma";
import { Documentos } from "../screens/Admin/Convocatorias/Documentos/Documentos";
import { DocumentosTecnicos } from "../screens/Admin/Convocatorias/DocumentosTecnicos/documentosTecnicos.view";
// import { DocumentacionConvocatoria } from "../screens/Admin/Convocatorias/DocumentacionGeneral/documentacionGeneral";

import { PublicarConvocatoria } from "../screens/Admin/Convocatorias/PublicarConvocatoria/publicarConvocatoria";
import { GestionarPostulacionesBesp } from "../screens/Admin/Beps/GestionarPostulaciones/GestionarPostulaciones";
import { GestionarJurados } from "../screens/Jurados/GestionarJurados/GestionarJurados";
// Components
import { LayoutMenu } from "../components/layout/LayoutMenu/layout.view";
import { Navbar } from "../components/Administrador/Navbar/Navbar";
import { InfoBeps } from "../screens/Admin/Beps/infoBeps/InfoBeps";
// style components
import { Layout } from "antd";
import { GestionarPostulacionesJurados } from "../screens/Jurados/GestionarPostulacionesJurados/GestionarPostulacionesJurados";
import { AsignarJurados } from "../screens/Jurados/AsignarJurados/AsignarJurados";
import { InvitacionJurados } from "../screens/Admin/InivitacionJurado/invitacion.view";
import { DocumentacionConvocatoria } from "../screens/Admin/Convocatorias/DocumentacionGeneral/documentacionGeneral";
import { ListadoPostulaciones } from "../screens/Admin/ListadoPostulaciones/listado-postulaciones.view";
import { SeguimientoProyectos } from "../screens/Admin/SeguimientoProyectos/seguimiento-proyectos";
import { GestionRoles } from "../screens/Admin/GestionRoles/Gestion.view";
import ValidateAccessMiddleware from "../middlewares/ValidateAccessMiddleware";
import { GestionarMaestras } from "../screens/Admin/Maestras/GestionarMaestras";
import { GestionLineasCategorias } from "../screens/Admin/Maestras/Pantallas/GestionLineasCategorias";
import { GestionAreas } from "../screens/Admin/Maestras/Pantallas/GestionAreas";
import { GestionDocAdmin } from "../screens/Admin/Maestras/Pantallas/GestionDocAdmin";
import { GestionarEntidad } from "../screens/Admin/Maestras/Pantallas/GestionarEntidad";
import { GestionarCiclo } from "../screens/Admin/Maestras/Pantallas/GestionarCiclo";
import { GestionDocTec } from "../screens/Admin/Maestras/Pantallas/GestionDocTec";
import { GestionarActividades } from "../screens/Admin/Maestras/Pantallas/GestionarActividades";
import { GestionarMaestrasJurados } from "../screens/Admin/Maestras/GestionarMaestrasJurados";
import { GestionarAreaCategorias } from "../screens/Admin/Maestras/Pantallas/GestionarAreaCategorias";
import { GestionLineaEstrategica } from "../screens/Admin/Maestras/Pantallas/GestionLineaEstrategica";
import { GestionCriterios } from "../screens/Admin/Maestras/Pantallas/GestionCriterios";

import { EnviarNotificaciones } from "../screens/Admin/Notificaciones/EnviarNotificaciones";
import { BancoJurado } from "../screens/Admin/BancoJurados/BancoJurado";
import { GestionEvaluador } from "../screens/Admin/Evaluador/GestionEvaluador";
import { TemplateContext } from "../utils/template_context";
import Home from "../components/Home/Home";

export const AdminRoute = () => {
  const context = useContext(TemplateContext);

  const authorizeRoute = () => {
    // if (!user) {
    //   navigate("/login/1/28");
    // }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      authorizeRoute();
    }
    return () => {
      mounted = false;
    };
  });

  return (
    <>
      <ValidateAccessMiddleware />
      <Layout className="height-100">
        {context.device !== "sm" && (
          <Layout.Sider
            className="sider-adminrouter"
            width={240}
            style={{ height: "100vh" }}
            trigger={null}
            collapsible
            collapsedWidth={0}
            collapsed={context.menu_collapsed}
          >
            <LayoutMenu />
          </Layout.Sider>
        )}
        <Layout className="background-color-F7FBFF height-100">
          <Navbar />
          <div style={{ height: "calc(100% - 49px)" }}>
            <Routes>
              <Route path="/" element={<Home/>/*<AdminConvocatorias />*/} />
              
              <Route path="/tablaconvocatorias" element={<AdminConvocatorias />} />
              {/* <Route path="/infoconvocatoria" element={<InfoConvocatoria />} /> */}
              <Route path="/infoconvocatoria" element={<InfoConvocatorias />} />
              <Route
                path="/cronogramaActividades"
                element={<CronogramaActividades />}
              />
              <Route path="/cronograma" element={<Cronograma />} />
              <Route path="/documentos" element={<Documentos />} />
              <Route
                path="/documentacionTecnica"
                element={<DocumentosTecnicos />}
              />
              <Route
                path="/documentacionConvocatoria"
                element={<DocumentacionConvocatoria />}
              />
              <Route
                path="/publicarConvocatoria"
                element={<PublicarConvocatoria />}
              />
              <Route path="/infoJurados" element={<Infojurados />} />
              <Route
                path="/documentacionAdministrativos"
                element={<DocumentosAdministrativos />}
              />
              <Route
                path="/gestionarPostulaciones"
                element={<GestionarPostulaciones />}
              />
              <Route
                path="/gestionarPostulacionesBeps"
                element={<GestionarPostulacionesBesp />}
              />
              <Route path="/gestionarJurados" element={<GestionarJurados />} />
              <Route
                path="/gestionarPostulacionesJurados"
                element={<GestionarPostulacionesJurados />}
              />
              <Route
                path="/evaluacionCriterios"
                element={<EvaluacionCriterios />}
              />
              <Route
                path="/invitacionJurados"
                element={<InvitacionJurados />}
              />
              <Route path="/infoBeps" element={<InfoBeps />} />
              <Route path="/asignarJurados" element={<AsignarJurados />} />
              <Route
                path="/listadoPostulaciones"
                element={<ListadoPostulaciones />}
              />
              <Route
                path="/seguimientoProyectos"
                element={<SeguimientoProyectos />}
              />
              <Route path="/gestionRoles" element={<GestionRoles />} />
              <Route
                path="/centroNotificaciones"
                element={<CentroNotificaciones />}
              />
              <Route
                path="/enviarNotificaciones"
                element={<EnviarNotificaciones />}
              />
              <Route path="/gestionMaestras" element={<GestionarMaestras />} />
              <Route
                path="/gestionMaestrasJurados"
                element={<GestionarMaestrasJurados />}
              />
              <Route
                path="/enviarNotificaciones"
                element={<EnviarNotificaciones />}
              />
              <Route
                path="/gestionarLineasCategorias"
                element={<GestionLineasCategorias />}
              />
              <Route
                path="/gestionarActividadesCronograma"
                element={<GestionarActividades />}
              />
              <Route
                path="/gestionarDocumentosAdministrativos"
                element={<GestionDocAdmin />}
              />
              <Route
                path="/gestionarDocumentosTecnicos"
                element={<GestionDocTec />}
              />
              <Route path="/gestionarEntidad" element={<GestionarEntidad />} />
              <Route path="/gestionarCiclos" element={<GestionarCiclo />} />
              <Route path="/gestionarAreas" element={<GestionAreas />} />
              <Route
                path="/gestionarAreasCategorias"
                element={<GestionarAreaCategorias />}
              />
              <Route
                path="/gestionarCriterios"
                element={<GestionCriterios />}
              />
              <Route
                path="/gestionarLineaEstrategica"
                element={<GestionLineaEstrategica />}
              />
              <Route path="/bancoJurados" element={<BancoJurado />} />
              <Route path="/gestionEvaluador" element={<GestionEvaluador />} />
            </Routes>
          </div>
        </Layout>
      </Layout>
    </>
  );
};
